module.exports = __webpack_public_path__ + "static/media/Sunset.3a6469e4.mp3";